export const Logo = () => (
	<svg width="24" height="24" fill="none" role="presentation">
		<g clipPath="url(#a)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.022 18.667A12 12 0 1 1 21.977 5.333 12 12 0 0 1 2.022 18.667zM9 7H7v10h2V7zm8 0h-6v2h6V7zm0 3.999h-6v2h6v-2zM17 15h-6v2h6v-2z"
				fill="#fff"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
);
